import { TTextAreaFieldProps } from "@/app/types/types";
import TextFieldResizeIcon from "../icons/TextFieldResizeIcon";
import { Field, useFormikContext } from "formik";

const TextAreaField = ({
	name,
	floatingLabel,
	error,
	errorMessage,
	placeholder,
	htmlFor,
	onChange,
	value
}: TTextAreaFieldProps) => {
	const formik = useFormikContext<any>()
	const fieldId = htmlFor ?? name;
	const fieldLabel = placeholder || name;

	return (
		<div
			className={`input_wrapper font-['national'] ${
				floatingLabel ? "floating_label" : ""
			} ${error ? "error" : ""}`}
		>
			<div className="input_container ">
				{!floatingLabel && (
					<label htmlFor={fieldId} className="sr-only">
						{fieldLabel}
					</label>
				)}
				<Field
					as="textarea"
					name={name}
					id={fieldId}
					className={`bg-oWhite-10 hover:bg-oWhite-24 w-full text-white ${formik?.values?.[name] ? "has_value" : ""}`}
					placeholder={floatingLabel ? "" : placeholder}
					onChange={onChange}
					value={value}
				/>
				{floatingLabel && (
					<label className="text-oWhite-60" htmlFor={fieldId}>
						{placeholder}
					</label>
				)}
				<div className="icon absolute bottom-4 right-3">
					<TextFieldResizeIcon color={error? "#ff0a0a" : "white"} />
				</div>
			</div>
			{error && (
				<p className="error-message bodyS">
					{errorMessage ? errorMessage : "Error"}
				</p>
			)}
		</div>
	);
};

export default TextAreaField;
